export default __webpack_public_path__ + "static/media/nacionalCredito.1b607a95.png";